import { useEffect, useState } from 'react';
import { useFormikContext } from 'formik';
import isEqual from 'lodash.isequal';
import PropTypes from 'prop-types';

export const FormObserver = ({ onChange }) => {
  const { values } = useFormikContext();
  const [prevValues, setPrevValues] = useState({});
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (initialized && !isEqual(values, prevValues)) {
      onChange(values);
    }

    if (!initialized) {
      setInitialized(true);
    }

    setPrevValues(values);
  }, [initialized, onChange, prevValues, values]);

  return null;
};

FormObserver.propTypes = {
  onChange: PropTypes.func.isRequired,
};
